export const aditionalValues = {
  campoadicionaltxt1: '',
  campoadicionaltxt2: '',
  campoadicionaltxt3: '',
  campoadicionaltxt4: '',
  campoadicionaltxt5: '',
  campoadicionalnum1: '',
  campoadicionalnum2: '',
  campoadicionalnum3: '',
  campoadicionalFec1: '',
  campoadicionalFec2: '',
}

const obj = Object.fromEntries(Array.from({length: 51}, (_, i) => [`R${i}`, 0]))

export const transformArray = (arr: any[]) => {
  const result = []

  for (let i = 0; i <= 50; i++) {
    const codigo = `R${i}`
    result.push({
      Codigo: codigo,
      Minimo: arr[0][codigo], // Valor de "Minimo" del primer objeto
      Maximo: arr[1][codigo], // Valor de "Maximo" del segundo objeto
    })
  }

  return result
}

export const initialRangeParameters = [
  {Rango: 'Minimo', ...obj},
  {Rango: 'Maximo', ...obj},
]

export const initialRangeParamsSch = transformArray(initialRangeParameters)
